import { Http } from '@/lib/http';

export class CommentsService extends Http {
  constructor() {
    super();
    this.endPoint = 'loan-pro/app/loan-comments'
  }

  createComment(comment) {
    return this.httpClient().post(`${this.endPoint}`, comment)
  }

  updateComment(id, updates) {
    return this.httpClient().patch(`${this.endPoint}/${id}`, updates)
  }

  getComments(loanId) {
    return this.httpClient().get(`${this.endPoint}/${loanId}`)
  }

  deleteComment(userId, commentId) {
    return this.httpClient().delete(`${this.endPoint}/${userId}/${commentId}`)
  }
}
